import { mergeStyleSets, useTheme } from "@fluentui/react";

export const useStyles = () => {
  const theme = useTheme();

  return mergeStyleSets({
    pickerListItem: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'white',
      padding: '0 6px',
      gap: '4px',
      '&:hover': {
        backgroundColor: theme.palette.neutralLighterAlt,
      },
      '&:hover .deleteButton': {
        visibility: 'visible',
      },
      '& .deleteButton': {
        visibility: 'hidden',
        height: '30px',
        width: '30px',
      },
    },
    dndGrip: {
      cursor: 'grab',
      display: 'flex',
      alignItems: 'center',
    },
    label: {
      flexGrow: 1,
      padding: '4px 0',
    },
  })
}
